<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import '@/styles/design-system.css'

const authStore = useAuthStore()

onMounted(() => {
  // 初始化时检查本地存储的token
  authStore.initializeAuth()
})
</script>

<style>
#app {
  height: 100vh;
  margin: 0;
  padding: 0;
  background: var(--bg-secondary);
}

/* Element Plus 组件样式覆盖 */
.el-button {
  border-radius: var(--radius-md);
  font-weight: 500;
  transition: all var(--transition-normal);
}

.el-button--primary {
  background: var(--primary-color);
  border: none;
}

.el-button--primary:hover {
  background: var(--primary-dark);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.el-card {
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border-light);
  transition: all var(--transition-normal);
}

.el-card:hover {
  box-shadow: var(--shadow-md);
}

.el-table {
  border-radius: var(--radius-lg);
  overflow: hidden;
  box-shadow: var(--shadow-sm);
}

.el-table th {
  background-color: transparent;
  color: var(--text-secondary);
  font-weight: 600;
  border-bottom: 2px solid var(--border-light);
}

.el-table .el-table__row:hover > td {
  background-color: var(--bg-tertiary) !important;
}

.el-table .el-table__row.current-row > td {
  background-color: transparent !important;
  border-left: 3px solid var(--primary-color);
}

.el-dialog {
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-2xl);
}

.el-dialog__header {
  background: transparent;
  color: var(--text-primary);
  border-bottom: 1px solid var(--border-light);
  padding: var(--spacing-lg) var(--spacing-xl);
}

.el-dialog__title {
  color: var(--text-primary);
  font-weight: 600;
}

.el-dialog__headerbtn .el-dialog__close {
  color: var(--text-secondary);
}

.el-form-item__label {
  color: var(--text-secondary);
  font-weight: 500;
}

.el-input__wrapper {
  border-radius: var(--radius-md);
  transition: all var(--transition-normal);
}

.el-input__wrapper:hover {
  box-shadow: var(--shadow-sm);
}

.el-tag {
  border-radius: var(--radius-sm);
  font-weight: 500;
}

.el-pagination {
  justify-content: center;
}

.el-pagination .el-pager li {
  border-radius: var(--radius-sm);
  margin: 0 2px;
}

.el-menu-item {
  border-radius: var(--radius-md);
  margin: 2px 8px;
  transition: all var(--transition-normal);
}

.el-descriptions {
  border-radius: var(--radius-lg);
  overflow: hidden;
}

/* 全局移动端优化 */
@media (max-width: 768px) {
  /* 表格在移动端的滚动优化 */
  .el-table {
    font-size: 14px;
  }

  .el-table .cell {
    padding-left: 8px;
    padding-right: 8px;
  }

  /* 表单在移动端的优化 */
  .el-form-item__label {
    font-size: 14px;
  }

  .el-input__inner {
    font-size: 16px; /* 防止iOS缩放 */
  }

  /* 按钮在移动端的优化 */
  .el-button--small {
    padding: 6px 12px;
    font-size: 12px;
  }

  /* 对话框在移动端的优化 */
  .el-dialog {
    width: 95% !important;
    margin: 0 auto;
  }

  .el-dialog__body {
    padding: 16px 20px;
  }

  /* 分页在移动端的优化 */
  .el-pagination {
    font-size: 14px;
  }

  .el-pagination .el-pager li {
    min-width: 32px;
    height: 32px;
    line-height: 32px;
  }

  /* 标签页在移动端的优化 */
  .el-tabs__item {
    padding: 0 12px;
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  /* 超小屏幕优化 */
  .el-dialog {
    width: 98% !important;
  }

  .el-dialog__body {
    padding: 12px 16px;
  }

  .el-form-item__label {
    font-size: 13px;
  }

  .el-button--small {
    padding: 4px 8px;
    font-size: 11px;
  }
}

/* 触摸设备优化 */
@media (hover: none) and (pointer: coarse) {
  .el-button:hover {
    background-color: initial;
    border-color: initial;
    color: initial;
  }

  .el-button--primary:hover {
    background: #409eff;
    border-color: #409eff;
    color: #fff;
  }
}
</style>
